<template>
  <div v-if="message">
    <div
      :class="{'incoming_msg' : message.enviado_por == 'admin', 'outgoing_msg' : message.enviado_por != 'admin'}"
    >
      <div class="incoming_msg_img" v-if="message.enviado_por == 'admin'">
        <img src="https://ptetutorials.com/images/user-profile.png" alt="sunil" />
      </div>
      <div class="received_msg" v-if="message.enviado_por == 'admin'">
        <div class="received_withd_msg">
          <p>
            {{ message.body }}
            <span class="time_date">{{ item.time }}</span>
          </p>
        </div>
      </div>
      <div class="outgoing_msg" v-else>
        <div class="sent_msg">
          <p>
            {{ message.body }}
            <a
              v-if="message.tipo == 'img'"
              data-fancybox="gallery"
              v-bind:href="message.imagem"
            >
              <img v-bind:src="message.imagem" style="width: 200px; height: auto" />
            </a>
            <audio controls v-if="message.tipo == 'aud'">
              <source v-bind:src="message.audio" type="audio/mpeg" />O seu navegador não suporta o elemento
              <code>audio</code>.
            </audio>
          </p>
          <span class="time_date">{{ item.time }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["item"],
  data: () => {
    return {
      message: null
    };
  },
  created() {
    this.getMessage();
  },
  methods: {
    async getMessage() {
      const m = await this.item.content.get();
      //console.log('getMessage',m.data());
      this.message = m.data();
    }
  }
};
</script>
